export default __webpack_public_path__ + "static/blocknative-81fd06fd9739a9896f6c91316760c706.png";